import { IsUser } from '../interfaces/is-user';

export class User implements IsUser {
	username: string;
	token: string;
	options: string[];

	constructor(username: string, token: string, options: string[]) {
		this.username = username;
		this.token = token;
		this.options = options;
	}
}
